import { render, staticRenderFns } from "./LaborProtectionAccidentsList.vue?vue&type=template&id=1b36febc&"
import script from "./LaborProtectionAccidentsList.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionAccidentsList.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionAccidentsList.vue?vue&type=style&index=0&id=1b36febc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports